export default "__VITE_ASSET__dpVq3ZII__"